import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DoctorForm from 'Component/DashboardQeza/Doctor/Form';
import { getDoctor } from 'Services/Features/Doctor/Utils/doctorUtils';
import { setFormData, resetFormData } from 'Services/Features/Doctor/doctorSlice';

const CategoryAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.doctor.filters)
    const currentDoctor = useSelector((state) => state.doctor.currentDoctor);
    const [refetch, setRefetch] = useState(false);

    // console.log(currentDoctor, 'currentDoctor');
    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentDoctor?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getDoctor(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & profile_picture ke state terpisah
                    dispatch(setFormData({ profile_pictureLink: item.profile_picture }));

                    // Buat objek baru tanpa photos & profile_picture
                    const { profile_picture, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                    }));
                }
            });
        } else if (currentDoctor?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentDoctor,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Dokter" title={id ? 'Edit Dokter' : 'Tambah Dokter'} />
            <DoctorForm label={id ? "" : "Dokter Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default CategoryAdd;